if(document.getElementById('app_share_zone') != null){

    document.addEventListener('alpine:init', () => {

        Alpine.data('app_share_zone', (route) =>({
            libQR : false,
            txtCopyOrigin : '✂️ Copier le lien',
            txtCopy : '✂️ Copier le lien',

            downloadButton : false,
            route : '',
            title_share : 'Feedelit',
            text_share : 'Feedelit',
            is_link_to_dashboard : false,
            is_link_generate_qr_by_default : false,
            hide_qr : false,
            init(){
                this.route = route;

                //document.getElementById('app_share_zone').dispatchEvent(new CustomEvent('refreshsharezone', { detail: {route : '{{route('fiche_pro',['nom_uri' => $pro->nom_uri])}}'}}))
                //document.getElementById('app_share_zone').dispatchEvent(new CustomEvent('refreshsharezone', { detail: {route : "machin"}}))
            },
            loadsharezone(d){
                console.log(d);
                this.route = d.route;
                this.hide_qr = true;
                if(typeof d.title != "undefined"){
                    this.title_share = d.title;
                }else{
                    this.title_share = 'Feedelit';
                }
                if(typeof d.text != "undefined"){
                    this.text_share = d.text;
                }else{
                    this.text_share = 'Feedelit';
                }
                if(typeof d.is_link_to_dashboard != "undefined"){
                    this.is_link_to_dashboard = d.is_link_to_dashboard;
                }else{
                    this.is_link_to_dashboard = false;
                }

                if(typeof d.is_link_generate_qr_by_default != "undefined"){
                    this.is_link_generate_qr_by_default = d.is_link_generate_qr_by_default;
                }else{
                    this.is_link_generate_qr_by_default = false;
                }

                document.getElementById('my-modal-sharzone').checked = true;
                this.$nextTick(() => {
                    if(typeof QRCode == "undefined"){
                        this.hide_qr = true;
                    }else{
                        if(this.is_link_generate_qr_by_default){
                            this.hide_qr = false;
                            this.QrCoder();
                        }else{
                            this.hide_qr = true;
                        }

                    }
                })


            },
            CopierLien(){
                navigator.clipboard.writeText(this.route);
                console.log(this.route);
                this.txtCopy = "Lien copié ! 😊";
                setTimeout(() => this.txtCopy = this.txtCopyOrigin, 1000)
            },
            QrCoder(){
                // Options
                this.hide_qr = false;
                var options = {
                    text: this.route,
                    //backgroundImage : '/images/logo2.png',
                    //backgroundImageAlpha : 0.5,
                    width : 1024,
                    height : 1024,
                    logo : '/images/logo2_modicon.png',
                    logoBackgroundTransparent : false,
                    onRenderingEnd :() =>{
                        this.downloadButton = true;
                    }
                };
                if(this.libQR == false){
                    // Create QRCode Object
                    this.libQR = new QRCode(document.getElementById("qrcode"), options);
                }else{
                    this.libQR.makeCode(this.route);
                }

                const canvas = document.querySelector('#qrcode canvas');
                if (!canvas) {
                    console.error('Canvas not found');
                    return;
                }

                // Ajouter une classe Tailwind CSS ou un style directement au canvas
                canvas.classList.add('w-full');
            },
            downloadQRcode(){
                // Download the png image or svg file
                // The '.png' or '.svg' suffix will be added to filename automatically
                var fileName = 'qrcode_'+this.title_share;
                const canvas = document.querySelector('#qrcode canvas');
                if (!canvas) {
                    console.error('Canvas not found');
                    return;
                }

                const image = canvas.toDataURL('image/png'); // Convertit le canvas en une image au format PNG
                const link = document.createElement('a');
                link.href = image;
                link.download = fileName+'.png'; // Nom du fichier téléchargé
                link.click();
            },
            navShare(){
                navigator.share({
                    url : this.route,
                    title :  this.title_share,
                    text :  this.text_share
                })
            }
        })
    )
    })

}
